module.exports = __webpack_public_path__ + "img/bluesky3100_21.29acefc0.jpg";